import { TextWidget } from "Components/optionForm";
import React, { memo, useCallback } from "react";
import { themeVariables } from "Components/theme";
const panelBodyStyle = {
    display: "grid",
    gap: themeVariables["padding-xs"],
    gridTemplateColumns: "1fr 1fr"
};
function isNumeric(str) {
    return /^-?\d*(\.\d+)?$/.test(str);
}
function SettingBlock(props) {
    var _a, _b, _c;
    const handleChangeDraft = useCallback((value) => {
        if (!props.onSettingChanged)
            return;
        const diff = isNumeric(value)
            ? {
                ValueNumber: parseInt(value),
                ValueString: null
            }
            : {
                ValueNumber: null,
                ValueString: value
            };
        props.onSettingChanged(props.type, diff);
    }, [props.type, props.onSettingChanged]);
    return (React.createElement("div", { style: panelBodyStyle },
        React.createElement(TextWidget, { value: ((_b = (_a = props.setting) === null || _a === void 0 ? void 0 : _a.ValueNumber) === null || _b === void 0 ? void 0 : _b.toString()) || ((_c = props.setting) === null || _c === void 0 ? void 0 : _c.ValueString) || "", label: props.title, labelMode: "floating", onChange: handleChangeDraft, readOnly: !props.onSettingChanged, height: 44 })));
}
export default memo(SettingBlock);
